const ENV = process.env.NODE_ENV || 'development';
const isProduction = ENV === 'production';
const isDebug = ENV === 'development';
const isClient = typeof window !== 'undefined';
const API_URL = isClient
  ? window.__INITIAL_STATE__.xl.api
  : process.env.API_URL || 'https://login.xsolla.com/api/';
const MFA_API_URL = isClient
  ? window.__INITIAL_STATE__.xl.MFA_API
  : process.env.MFA_API_URL || 'https://mfa-login.xsolla.com/api/';
const MERCHANT_API_URL = isClient
  ? window.__INITIAL_STATE__.xl.merchantApi
  : process.env.MERCHANT_API_URL || 'https://api.xsolla.com/';
const PORT = process.env.NODE_SOCKET || process.env.PORT || '3000';
const CDN = process.env.NODE_CDN_PATH || '/dist';
const METRICS = process.env.METRICS === 'true' || false;
const DOMAIN = isDebug ? 'localhost' : '.xsolla.com';
const DOC_HREF = 'https://developers.xsolla.com/doc/login/';
const DESTROY_CONNECTION_TIMEOUT = 5000;
const FORCE_SHUTDOWN_TIMEOUT = 10000;

module.exports = {
  ENV,
  isProduction,
  isDebug,
  isClient,
  API_URL,
  MFA_API_URL,
  MERCHANT_API_URL,
  PORT,
  CDN,
  METRICS,
  DOMAIN,
  DOC_HREF,
  DESTROY_CONNECTION_TIMEOUT,
  FORCE_SHUTDOWN_TIMEOUT
};



// WEBPACK FOOTER //
// ../common/configs/index.js